<div class="row catalog-products">
  @if (showHelpMeChoose()) {
    <app-access-control [notForViewer]="true">
      <ng-container ngProjectAs="[slot][content]">
        <div class="p-xs-0 mb-xs-1" [ngClass]="layoutType === 'grid' ? 'col-grid' : 'col-12'">
          <app-help-me-choose
            [layoutType]="layoutType"
            [contractParams]="contractParams">
          </app-help-me-choose>
        </div>
      </ng-container>
    </app-access-control>
  }
  @for (product of products; track product) {
    <div
       [ngClass]="{'p-xs-0 mb-xs-1': isUsStore && product?.productConfigurationInstance,
                   'col-grid': layoutType === 'grid', 
                   'col-12': layoutType !== 'grid'}">
      @if (!isSapStore && !product?.productConfigurationInstance) {
        <app-basic-product
          [layoutType]="layoutType"
          [itemsInQueueToCart]="itemsInQueueToCart"
          [product]="product"
          [labels]="labels"
          [wishlists]="wishlists"
          [isWishlistsActive]="isWishlistsActive"
          [addNewModalActive]="addNewModalActive"
          [loadingCartDataInProgress]="loadingCartDataInProgress"
          [isProductVariantsEnabled]="(isProductVariantsEnabled$ | async) ?? false"
          (addNewWishlistModalActive)="addNewModalActive = $event"
          (addProductToCart)="addToCart($event)">
        </app-basic-product>
      }
      @if (isSapStore && isSparePartsEnabled && !product?.productConfigurationInstance) {
        <app-spare-part-product
          [layoutType]="layoutType"
          [itemsInQueueToCart]="itemsInQueueToCart"
          [product]="product"
          [labels]="labels"
          [wishlists]="wishlists"
          [isWishlistsActive]="isWishlistsActive"
          [addNewModalActive]="addNewModalActive"
          [currentCart]="currentCart"
          [systemDetails]="systemDetails"
          [loadingCartDataInProgress]="loadingCartDataInProgress"
          (addNewWishlistModalActive)="addNewModalActive = $event"
          (addProductToCart)="addToCart($event)">
        </app-spare-part-product>
      }
      @if (isUsStore && isCpqEnabled && product?.productConfigurationInstance) {
        <app-configurable-product
          [layoutType]="layoutType"
          [contractParams]="contractParams"
          [itemsInQueueToCart]="itemsInQueueToCart"
          [product]="product"
          (selectContract)="handleSelectContract($event)">
        </app-configurable-product>
      }
    </div>
  }
  <app-add-new-wishlist
    [showModal]="addNewModalActive"
    (closeModal)="addNewModalActive = false"
    (created)="wishlistCreated()">
  </app-add-new-wishlist>
  <app-add-item-modal
    [showModal]="addItemToCartModalActive"
    (closeModal)="addItemToCartModalActive = false"
    [items]="itemToAdd"
    [currentCartId]="currentCartId">
  </app-add-item-modal>
  <app-modal-confirm
    [type]="iconType.WARNING"
    modalTitle="{{ 'catalog.select-equipment-modal.title' | translate }}"
    notifyText="{{ 'catalog.select-equipment-modal.text' | translate }}"
    cancelBtnText="{{ 'catalog.select-equipment-modal.cancel-btn' | translate }}"
    primaryBtnText="{{ 'catalog.select-equipment-modal.submit-btn' | translate }}"
    [showModalConfirm]="showModalSelectEquipment"
    (closeModalConfirm)="showModalSelectEquipment = false"
    (primaryActionConfirm)="selectEquipment()">
  </app-modal-confirm>
</div>
